// 水印操作
import Watermark from '@/util/watermark';
export default {
  methods: {
    createWaterMark() {
      const me = this;
      const isScrm = me.isScrm || false;
      this.$util.async.getWatermark({ isScrm }).then(watermark => {
        if (!watermark) {
          return;
        }
        const config = Watermark.createConfig({
          root: me.$refs && me.$refs.watermarkArea,
          mark: watermark.__watermark,
          alpha: watermark.__globalAlpha
        });
        Watermark.create(config);
      });

      this.$once('hook:destroy', () => {
        Watermark.destroy();
      });
    },
  }
}